<template>
    <div>
        <p class="timeline-talks" v-html="message"></p>
    </div>
</template>

<script>
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: ['details'],
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        message() {
            if (this.details.currentObj.riskLevel) {
                return (
                    'Manual alert has been created with override risk rating to ' +
                    this.details.currentObj.riskLevel +
                    ' Risk with the following comment,<br>' +
                    this.details.currentObj.comments
                )
            }
            return 'Manual alert has been created with override risk rating to High Risk with the following comment.'
        },
    },
}
</script>
